// src/pages/ContractorNexusHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const ContractorNexusHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Productivity Suite 1", emoji: "⚡" },
    { label: "Compliance Suite", emoji: "📋" },
    { label: "Productivity Suite 2", emoji: "🪞" },
    { label: "Contractor CCM", emoji: "📅" },
    { label: "Learning & Development", emoji: "📚" },
    { label: "Digital Income", emoji: "💰" },
    { label: "People & Kaizen", emoji: "👥" },
    { label: "Market & Engagement", emoji: "🛍️" },
    { label: "ContractorNexus", emoji: "🧗" },
  ];

  const menuButtons1 = [
    // Productivity Suite 1 
    { label: "Worker's Attendance", emoji: "📅", link: "/chronocheck-home", group: "Productivity Suite 1 Suite 1" },
    { label: "Principal Employer", emoji: "👔", link: "/think-contract-principal-employer", group: "Productivity Suite 1" },
    { label: "Contractor", emoji: "👷", link: "/think-contract-contractor", group: "Productivity Suite 1" },
    { label: "Workforce", emoji: "🧑‍🤝‍🧑", link: "/think-contract-workers", group: "Productivity Suite 1" },
    { label: "Urgent-Important Matrix", emoji: "📈", link: "/sprintcentral-uimatrix", group: "Productivity Suite 1" },
    { label: "PERT Time Estimation", emoji: "⏱️", link: "/sprintcentral-threepf", group: "Productivity Suite 1" },
    { label: "WBS", emoji: "📝", link: "/sprintcentral-wbs", group: "Productivity Suite 1" },
    { label: "Data Visualisation", emoji: "📊", link: "/think-contract-data", group: "Productivity Suite 1" },
    { label: "Earned Value Management", emoji: "💹", link: "/sprintcentral-evm", group: "Productivity Suite 1" },
    { label: "Jobs Board", emoji: "🛒", link: "/bluehands-home", group: "Productivity Suite 1" }, 

    // Compliance Suite 
    // === For Principal Employer ===
    { label: "Form I – Principal Employer Details", emoji: "📝", link: "/compliance/form-i", group: "Compliance Suite" },
    { label: "Form V – Completed Reports", emoji: "✅", link: "/compliance/form-v", group: "Compliance Suite" },
    { label: "Form VI A – Signatory Documents", emoji: "✍️", link: "/compliance/form-vi-a", group: "Compliance Suite" },
    { label: "Register of Contractors", emoji: "📋", link: "/compliance/register-of-contractors", group: "Compliance Suite" },
    
    // === For Contractor ===
    { label: "Form IV – Contract Details", emoji: "📄", link: "/compliance/form-iv", group: "Compliance Suite" },
    { label: "Form VI – Contractor Submissions", emoji: "🗂️", link: "/compliance/form-vi", group: "Compliance Suite" },
    { label: "Form VI B – Supporting Docs", emoji: "📑", link: "/compliance/form-vi-b", group: "Compliance Suite" },
    { label: "Form XII – Standard Documents", emoji: "📄", link: "/compliance/form-xii", group: "Compliance Suite" },
    { label: "Form XIII – Checklist", emoji: "📋", link: "/compliance/form-xiii", group: "Compliance Suite" },
    { label: "Form XIV – Contractor Listing", emoji: "📜", link: "/compliance/form-xiv", group: "Compliance Suite" },
    { label: "Form XV – Task Records", emoji: "🗒️", link: "/compliance/form-xv", group: "Compliance Suite" },
    { label: "Form XVI – Filled Forms", emoji: "📂", link: "/compliance/form-xvi", group: "Compliance Suite" },
    { label: "Form XVII – Archived Records", emoji: "🗄️", link: "/compliance/form-xvii", group: "Compliance Suite" },
    { label: "Form XIX – Schedule Check", emoji: "📅", link: "/compliance/form-xix", group: "Compliance Suite" },
    { label: "Form XX – Completed Tasks", emoji: "☑️", link: "/compliance/form-xx", group: "Compliance Suite" },
    { label: "Form XXI – Verified Forms", emoji: "✅", link: "/compliance/form-xxi", group: "Compliance Suite" },
    { label: "Form XXII – Financial/Spreadsheet", emoji: "📊", link: "/compliance/form-xxii", group: "Compliance Suite" },
    { label: "Form XXIII – General Forms", emoji: "📝", link: "/compliance/form-xxiii", group: "Compliance Suite" },
    // === Other Records & Registers ===
    { label: "Form XXIV – Miscellaneous Records", emoji: "📄", link: "/compliance/form-xxiv", group: "Compliance Suite" },
    { label: "Annual Return", emoji: "📈", link: "/compliance/annual-return", group: "Compliance Suite" },
    { label: "Health & Safety Registers", emoji: "💓", link: "/compliance/health-safety-registers", group: "Compliance Suite" },

    // 💰 DIGITAL INCOME
    { label: "Monthly Digital Income", emoji: "💻🌱", link: "/msme-bookworld", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Income" },

    // 📚 Learning & Development
    { label: "Contractor Learning", emoji: "🗓️", link: "/msme-bookworld", group: "Learning & Development" },
    { label: "Contract Bookshelf", emoji: "📖", link: "/bookshelf", group: "Learning & Development" },
    { label: "Contract Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Learning & Development" },
    { label: "Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Learning & Development" },
    { label: "contractTube", emoji: "️▶️", link: "/msmrtube", group: "Learning & Development" },

    // 🪞 Productivity Suite 2 
    { label: "Business Digital Card", emoji: "💼", link: "/msme-digitalcard", group: "Productivity Suite 2" },
    { label: "DeepThinking Lab", emoji: "🔍", link: "/fivewhys-analysis-home", group: "Productivity Suite 2" },
    { label: "Contracting Chronicles", emoji: "📖", link: "/msme-business-chronicles", group: "Productivity Suite 2" },
    { label: "Contracting Diary", emoji: "📓", link: "/mydiary-home", group: "Productivity Suite 2" },
    { label: "Contractor Journal", emoji: "🗒️", link: "/myjournal-home", group: "Productivity Suite 2" },
    { label: "Minutes of Meeting", emoji: "✍️", link: "/tasks/add", group: "Productivity Suite 2" },
    { label: "Goal Board", emoji: "🏁", link: "/msme-goalboard", group: "Productivity Suite 2" },
    { label: "Process & RACI Board", emoji: "🧩", link: "/msme-processraci", group: "Productivity Suite 2" },
    { label: "Kanban", emoji: "📊", link: "/msme-kanban", group: "Productivity Suite 2" },
    { label: "Auto Payment Reminder", emoji: "⏰💳", link: "/prs", group: "Productivity Suite 2" },
    { label: "Contractors's Self Management", emoji: "🙋‍♀️", link: "/msme-self-chronicles", group: "Productivity Suite 2" },
    { label: "Self Reflection Diary", emoji: "📔", link: "/mydiary-home", group: "Productivity Suite 2" },
    { label: "Focus Timer", emoji: "⏱️", link: "/msme-focustimerstart", group: "Productivity Suite 2" },
    { label: "My Outreach", emoji: "📣👥", link: "/outreach", group: "Productivity Suite 2" },
    { label: "My Limit", emoji: "️📏", link: "/mylimit", group: "Productivity Suite 2" },
    { label: "Personal AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Productivity Suite 2" },
    
    // 🔄 Contractor CCM (Contacts. Communication. Meetings)
    { label: "My Digital Card", emoji: "💼", link: "/contract-digitalcard", group: "Contractor CCM" },
    { label: "Client's Digital Card", emoji: "👤", link: "/contact-genious-clientcards", group: "Contractor CCM" },
    { label: "My Speaking Card", emoji: "🎙️", link: "/contact-genious-speakingcard", group: "Contractor CCM" },
    { label: "Card Visibility Dashboard", emoji: "📊", link: "/contact-genious-cardviewstats", group: "Contractor CCM" },
    { label: "Connect / PehchaanSetu", emoji: "🤝", link: "/pehchaansetu", group: "Contractor CCM" },
    { label: "Meeting Calendar", emoji: "📅", link: "/calendar-list", group: "Contractor CCM" },
    { label: "Visits for Meeting", emoji: "📍", link: "/visits-list", group: "Contractor CCM" },
    { label: "Meeting Thoughts", emoji: "💭", link: "/thoughts-list", group: "Contractor CCM" },
    { label: "Meeting TODO", emoji: "✅", link: "/todo-list", group: "Contractor CCM" },
    { label: "Meeting Tasks", emoji: "🛠️", link: "/tasks-list", group: "Contractor CCM" },
    { label: "Travelling for Meetings", emoji: "🚗", link: "/travels-list", group: "Contractor CCM" },
    { label: "Meeting Checklist", emoji: "📋", link: "/checklist-list", group: "Contractor CCM" },
    { label: "Meeting Record", emoji: "🗂️", link: "/meetings-list", group: "Contractor CCM" },
    { label: "Whisper", emoji: "🤫", link: "", group: "Contractor CCM" },
    { label: "Meeting Analytics AI", emoji: "🧠📈", link: "", group: "Contractor CCM" },

    // 👥 People & Kaizen
    { label: "BlueHands", emoji: "👐", link: "/bluehands-home", group: "People & Kaizen" },
    { label: "Contractor Ranking", emoji: "🏆", link: "/udyampragatiscore", group: "People & Kaizen" },
    { label: "Contractor Database", emoji: "💾", link: "/msmedb", group: "People & Kaizen" },
    { label: "Contracting AI Counselling", emoji: "🧠", link: "/aicounselling", group: "People & Kaizen" },    
    { label: "Digital Boutique", emoji: "🏬", link: "/digiboutique", group: "People & Kaizen" },
    { label: "Consultants", emoji: "🧑‍💼", link: "/think5whys-counsellors", group: "People & Kaizen" },
    { label: "Offboarded DB", emoji: "📤", link: "/offboarded-home", group: "People & Kaizen" },
    { label: "Payment Dodger DB", emoji: "🚫💰", link: "/offboarded-home", group: "People & Kaizen" },

    // PehchaanSetu 
    // { label: "PehchaanSetu", emoji: "🔗", link: "/pehchaansetu", group: "PehchaanSetu" },

    // Market & Engagement
    { label: "Contractor Marketplace", emoji: "🏪", link: "/orderflow-home", group: "Market & Engagement" },
    { label: "Forum", emoji: "🗣️", link: "/povify-home", group: "Market & Engagement" },
    { label: "TwiWrold", emoji: "🌐", link: "/twiworld", group: "Market & Engagement" },

    // ContractorNexus Adoption
    { label: "Ladder", emoji: "🪜", link: "/contract-think5whysmaturity", group: "ContractorNexus" },
    { label: "Stakeholders", emoji: "👨‍💼", link: "/contract-think5whysroles", group: "ContractorNexus" },

    // Artificial Contract Intelligence
    // { label: "AI for Contract", emoji: "👨‍💼", link: "/agenticsim", group: "Contractor AI" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">🏗️ ContractorNexus AI</div>
          <div className="text-[11px] text-gray-200">Contract and Contractor Lifecycle Manager</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-18 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-cyan-800 text-white text-xs lg:text-sm py-2">
        <div className="px-1 flex flex-wrap justify-center gap-2">
          <a href="/msme-whysakshammsme" className="hover:text-yellow-200">💭 About</a>
          <a href="/ledger" className="hover:text-yellow-200">📊 ERP</a>
          <a href="/msme-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
          <a href="/pehchaansetu" className="hover:text-yellow-200">🔗 PehchaanSetu</a>
        </div>
      </div>

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContractorNexusHome;
